import type { ReactElement, SVGProps } from 'react'

/**
 * Close (×) glyph for CloseButton (18 × 18).
 *
 * Path data byte-identical to
 * `metro/docs/superpowers/specs/assets/routecard-v2/icon-close.svg`
 * (Figma export). Two stroked paths, stroke 1.6, round caps; bound to
 * `currentColor` so the button tints via `text/secondary`.
 */
export function IconClose(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M4 4L14 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M14 4L4 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}
